module.exports = __webpack_public_path__ + "fonts/Graphik-Medium.woff";